import { Middleware } from '@reduxjs/toolkit';
import { TypesEnum as ApiCallTypesEnum, ApiCall } from '../api/types';
import * as actions from '../api/action';
import { RequestData } from '../../../../libs/RequestData';
import { msalInstance } from '../../../auth';

const apiMiddleware: Middleware = ({ dispatch }) => (next) => async (action) => {
    if (action.type !== ApiCallTypesEnum.apiCallBegan) return next(action);

    const { url, method, safe, params, body, onStart, onSuccess, onError }: ApiCall = action.payload;

    let Id;
    if (safe) {
        Id = msalInstance.getActiveAccount()?.localAccountId ?? '';
    }

    if (onStart) dispatch({ type: onStart });
    next(action);

    try {
        const response = await RequestData.makeRequest({
            url,
            method,
            params,
            body: safe ? ({ ...body, Id } as any) : body,
        });

        if (onSuccess) {
            // Specific
            dispatch({ type: onSuccess, payload: response });
        } else {
            // General
            dispatch(actions.apiCallSuccess(response));
        }
    } catch (error) {
        if (onError) {
            // Specific
            dispatch({ type: onError, payload: error.message });
        } else {
            // General
            dispatch(actions.apiCallFailed(error.message));
        }
    }
};

export default apiMiddleware;
